import { useCallback } from 'react';
import { ANNOTATION_EVENT_NAMES, QUESTIONNAIRE_EVENT_NAMES } from '../../../analytics/event-name';
import useAnalytics from '../../../analytics/useAnalytics';
import { SIDE_PANEL_EVENT_NAMES } from './event-name';
import type { DeleteAnnotationPayloadT, DeleteAnnotationsPayloadT, QuestionnairePayloadT, SelectAnnotationPayloadT, SelectLabelPayloadT, ToggleLockAnnotationPayloadT, ToggleLockLabelPayloadT, ToggleRenderAllAnnotationsPayloadT, ToggleVisibilityAllAnnotationsPayloadT, ToggleVisibilityAnnotationPayloadT, ToggleVisibilityLabelPayloadT, UpdateAnnotationLabelPayloadT } from './types';
const useAnalyticsForSidePanel = () => {
  const {
    sendEvent
  } = useAnalytics();
  const sendEventForAnnotationSelection = useCallback((payload: SelectAnnotationPayloadT) => {
    sendEvent({
      action: SIDE_PANEL_EVENT_NAMES.SELECT_ANNOTATION,
      payload
    });
  }, [sendEvent]);
  const sendEventForLabelSelection = useCallback((payload: SelectLabelPayloadT) => {
    sendEvent({
      action: SIDE_PANEL_EVENT_NAMES.SELECT_LABEL,
      payload
    });
  }, [sendEvent]);
  const sendEventForDeleteAnnotation = useCallback((payload: DeleteAnnotationPayloadT) => {
    sendEvent({
      action: ANNOTATION_EVENT_NAMES.DELETE_ANNOTATION,
      payload
    });
  }, [sendEvent]);
  const sendEventForDeleteAnnotations = useCallback((payload: DeleteAnnotationsPayloadT) => {
    sendEvent({
      action: ANNOTATION_EVENT_NAMES.DELETE_ANNOTATIONS,
      payload
    });
  }, [sendEvent]);
  const sendEventForUpdateAnnotationLabel = useCallback((payload: UpdateAnnotationLabelPayloadT) => {
    sendEvent({
      action: SIDE_PANEL_EVENT_NAMES.UPDATE_ANNOTATION_LABEL,
      payload
    });
  }, [sendEvent]);
  const sendEventForToggleLockAnnotation = useCallback((payload: ToggleLockAnnotationPayloadT) => {
    sendEvent({
      action: SIDE_PANEL_EVENT_NAMES.TOGGLE_LOCK_ANNOTATION,
      payload
    });
  }, [sendEvent]);
  const sendEventForToggleLockLabel = useCallback((payload: ToggleLockLabelPayloadT) => {
    sendEvent({
      action: SIDE_PANEL_EVENT_NAMES.TOGGLE_LOCK_LABEL,
      payload
    });
  }, [sendEvent]);
  const sendEventForToggleVisibilityAnnotation = useCallback((payload: ToggleVisibilityAnnotationPayloadT) => {
    sendEvent({
      action: SIDE_PANEL_EVENT_NAMES.TOGGLE_VISIBILITY_ANNOTATION,
      payload
    });
  }, [sendEvent]);
  const sendEventForToggleVisibilityLabel = useCallback((payload: ToggleVisibilityLabelPayloadT) => {
    sendEvent({
      action: SIDE_PANEL_EVENT_NAMES.TOGGLE_VISIBILITY_LABEL,
      payload
    });
  }, [sendEvent]);
  const sendEventForToggleVisibilityAllAnnotations = useCallback((payload: ToggleVisibilityAllAnnotationsPayloadT) => {
    sendEvent({
      action: SIDE_PANEL_EVENT_NAMES.TOGGLE_VISIBILITY_ALL_ANNOTATIONS,
      payload
    });
  }, [sendEvent]);
  const sendEventForToggleRenderAllAnnotations = useCallback((payload: ToggleRenderAllAnnotationsPayloadT) => {
    sendEvent({
      action: SIDE_PANEL_EVENT_NAMES.TOGGLE_RENDER_ALL_ANNOTATIONS,
      payload
    });
  }, [sendEvent]);
  const sendEventForQuestionnaireSkipped = useCallback((payload: QuestionnairePayloadT) => {
    sendEvent({
      action: QUESTIONNAIRE_EVENT_NAMES.QUESTIONNAIRE_SKIPPED,
      payload
    });
  }, [sendEvent]);
  const sendEventForQuestionnaireAnswered = useCallback((payload: QuestionnairePayloadT) => {
    sendEvent({
      action: QUESTIONNAIRE_EVENT_NAMES.QUESTIONNAIRE_ANSWERED,
      payload
    });
  }, [sendEvent]);
  const sendEventForQuestionnaireUpdated = useCallback((payload: QuestionnairePayloadT) => {
    sendEvent({
      action: QUESTIONNAIRE_EVENT_NAMES.QUESTIONNAIRE_UPDATED,
      payload
    });
  }, [sendEvent]);
  return {
    sendEventForAnnotationSelection,
    sendEventForLabelSelection,
    sendEventForDeleteAnnotation,
    sendEventForToggleLockAnnotation,
    sendEventForToggleLockLabel,
    sendEventForToggleVisibilityAnnotation,
    sendEventForToggleVisibilityAllAnnotations,
    sendEventForToggleRenderAllAnnotations,
    sendEventForUpdateAnnotationLabel,
    sendEventForToggleVisibilityLabel,
    sendEventForQuestionnaireSkipped,
    sendEventForQuestionnaireAnswered,
    sendEventForQuestionnaireUpdated,
    sendEventForDeleteAnnotations
  };
};
export default useAnalyticsForSidePanel;